import React, { forwardRef } from 'react';
import './style.scss';

interface SearchInputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onClear?: () => void;
    placeholder?: string;
    autoFocus?: boolean;
    className?: string;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(({
    value,
    onChange,
    onClear,
    placeholder = 'Search',
    autoFocus = false,
    className = '',
}, ref) => {
    const handleClear = () => {
        if (onClear) {
            onClear();
        } else {
            // Create a synthetic event to clear via onChange
            const syntheticEvent = {
                target: { value: '' }
            } as React.ChangeEvent<HTMLInputElement>;
            onChange(syntheticEvent);
        }
    };

    return (
        <div className={`search-input-wrapper ${className}`}>
            <i className="fal fa-search search-icon" aria-hidden="true" />
            <input
                ref={ref}
                type="text"
                className="form-control form-control-sm search-input"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                autoFocus={autoFocus}
                data-lpignore={true}
            />
            {value && (
                <button
                    type="button"
                    className="clear-button"
                    onClick={handleClear}
                    title="Clear search"
                    aria-label="Clear search"
                >
                    <i className="fal fa-times" aria-hidden="true" />
                </button>
            )}
        </div>
    );
});

SearchInput.displayName = 'SearchInput';

export default SearchInput;
